<div class="prevention-container">
  <div style="margin-top: 20px; margin-bottom: 20px">
    <div>Monitor and manage the AI Runtime prevention mechanism to protect against RAG poisoning.</div>
  </div>
  <div style="display: flex; font-weight: bold; margin-top: 20px">Malicious Files</div>

  <div style="margin-bottom: 20px">
    <div>Files flagged by the prevention mechanism as malicious. Click to explore detailed content.</div>
  </div>

  <app-prime-table
    #table
    class="table-component"
    queryParamProperty="prevention"
    [data$]="preventionCurrentPage$"
    [rowsPerPage]="50"
    [columns]="columns()"
    [isLoading]="isLoading()"
    (rowSelected)="rowSelected($event)"
    (rowUnselected)="rowUnselected()"
    [withCheckboxSelection]="false"
    [withActions]="false"
    [sortedColumn$]="sortedColumn$"
    [pageInfo]="pageInfo$.value"
    [tabelWithIcon]="false"
    tableNotFoundText="No prevention found"
    tableNotFoundIcon="assets/images/common/no-results-found.svg"
  >
  </app-prime-table>

  <div style="display: flex; font-weight: bold; margin-top: 20px">Threat Intelligence Analysis</div>

  <div style="margin-bottom: 20px">
    <div>This prevention mechanism is powered by Zenity’s threat intelligence feed.</div>
  </div>

  <div class="stats-container">
    <!-- Currently monitoring section -->
    <div class="stat-block">
      <div class="stat-label">Currently monitoring</div>
      <div class="value-row">
        <div class="stat-value">722</div>
        <div class="stat-subtext">Prompt Patterns</div>
      </div>
    </div>

    <!-- Growth section -->
    <div class="stat-block">
      <div class="stat-label">Growth</div>
      <div class="growth-container">
        <div class="growth-value">+20</div>
        <div class="bar-chart">
          <!-- Example bars -->
          <div class="bar bar-1"></div>
          <div class="bar bar-2"></div>
          <div class="bar bar-3"></div>
          <div class="bar bar-4"></div>
          <div class="bar bar-5"></div>
          <div class="bar bar-6"></div>
          <div class="bar bar-7"></div>
        </div>
      </div>
    </div>

    <!-- Last updated section -->
    <div class="stat-block">
      <div class="stat-label">Last updated</div>
      <div>
        {{ lastUpdated | date: 'MMM dd, yyyy' }}
        <br />
        {{ lastUpdated | date: 'HH:mm' }}
      </div>
    </div>
  </div>
  <div style="display: flex; font-weight: bold; margin-top: 20px; margin-bottom: 10px">DLP Configuration</div>

  <div class="menu-bar">
    <!-- First dropdown -->
    <div class="input-container">
      <label for="triggerSelect" class="input-title">Update Format</label>
      <select id="triggerSelect" class="input-box">
        <option>Automatic</option>
        <!-- Add more options as needed -->
      </select>
    </div>

    <!-- Second dropdown -->
    <div class="input-container">
      <label for="frequencySelect" class="input-title">Cadence</label>
      <select id="frequencySelect" class="input-box">
        <option>Daily</option>
        <!-- Add more options as needed -->
      </select>
    </div>
    <div class="explore-resource-link-container">
      <a class="explore-resource-link" [href]="" target="_blank"> Explore in DLP Platform </a>
      <img src="assets/images/common/link.svg" />
    </div>
  </div>
</div>
